import { Skeleton } from '@avanta/shared/components/ui/Skeleton';

const PackSkeleton = (): React.ReactElement => (
  <div className="flex w-full px-3.5 py-2 am-lg:py-4 flex-col items-center gap-1 am-lg:gap-2 rounded-xl border border-gray-200">
    <Skeleton className="size-8 rounded-full" />
    <Skeleton className="h-3.5 w-1/2" />
    <Skeleton className="h-3 w-full" />
  </div>
);

export const PaymentSkeleton = (): React.ReactElement => (
  <>
    <div className="flex flex-col gap-4">
      <Skeleton className="h-4 w-48" />
      <div className="grid grid-cols-2 gap-4">
        <PackSkeleton />
        <PackSkeleton />
      </div>
    </div>
    <div className="flex justify-between gap-4">
      <Skeleton className="h-11 w-28 rounded-full" />
      <Skeleton className="h-11 flex-1 am-lg:flex-none am-lg:w-35 rounded-full" />
    </div>
  </>
);
